import HomeView from "./home"

export default HomeView



// WEBPACK FOOTER //
// ./src/pages/index.jsx